module.exports = __webpack_public_path__ + "img/beijing_product.8449ba96.png";